import { Tab } from '../models/tabs.models';

export const ALARMS_TABS: Tab[] = [
  {
    id: 'rsabt',
    label: 'Remota',
    suffix: '10',
    icon: 'icons:remote',
    active: true,
  },
  {
    id: 'tsabt',
    label: 'Tarjeta',
    suffix: '8',
    icon: 'icons:tsabt',
    active: false,
  },
  {
    id: 'vtn',
    label: 'Remota VTN',
    suffix: '32',
    icon: 'icons:vtn',
    active: false,
  },
];
